import { currentPage } from '../common/layout';
import '../common/polymer/webcomponents-init';


currentPage.pageInit = ($page, pageData, pageId) => {}